<template>
  <v-app id="inspire">
    <v-navigation-drawer app permanent width="260" style="background: #0075ff">
      <v-app-bar elevation="1" style="background: #0075ff" height="73px">
        <div class="row header_logo py-5 px-4 justify-center">
          <img width="130px" src="@/assets/images/qamtu_logo_white.png" />
        </div>
      </v-app-bar>

      <v-list color="transparent" class="navbar-menu mt-5" dark>
        <div v-for="(menuItem, menuKey) in menuItems['1']" :key="menuKey">
          <template>
            <v-list-item
              :to="menuItem.url"
              :class="{
                'v-list-item--active': menuItem.id == $route.params.dir,
              }"
            >
              <v-list-item-icon class="mr-4">
                <v-icon>{{ menuItem.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> {{ menuItem.name }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </div>

        <v-divider class="my-3"></v-divider>
        <v-list-item @click="logout" link>
          <v-list-item-icon class="mr-4">
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> {{ $t("Выход") }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-divider class="my-2"></v-divider> -->
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      elevation="1"
      class="px-4"
      style="background: #fff"
      height="73px"
    >
      <v-toolbar-title class="font-weight-medium" v-if="sideBarData">{{
        sideBarData.user.full_name
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed v-bind="attrs" v-on="on">
            {{ languages[selectedLanguage] }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            link
            v-for="(item, index) in languages"
            :key="index"
            @click.stop="changeLanguage(index)"
          >
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main class="mt-4" style="background-color: #f5f9ff">
      <v-container fluid>
        <v-row>
          <v-col xl="9" lg="8" md="8" sm="8" class="pl-7">
            <router-view :key="$route.path" @get-data="getData" :data="sideBarData" />
          </v-col>
          <v-col xl="3" lg="4" md="4" sm="4" class="pr-7 pl-5" v-if="sideBarData">
            <h3 class="pb-4">{{ $t("Ваш статус") }}:</h3>

            <ol class="my_list mb-8">
              <li class="active">
                <template v-if="selectedLanguage == 'kk'">
                  {{ $t("место в общей очереди") }} - <b>{{ sideBarData.raiting }}</b>
                </template>
                <template v-else>
                  <b>{{ sideBarData.raiting }}</b> {{ $t("место в общей очереди") }}
                </template>
              </li>
              <li class="active" v-if="sideBarData.user.privilege">
                <template v-if="selectedLanguage == 'kk'">
                  "{{ sideBarData.user.privilege.description }}" {{ $t("место в очереди по категории") }} - <b>{{ sideBarData.privilege_raiting }}</b>
                </template>
                <template v-else>
                  <b>{{ sideBarData.privilege_raiting }}</b> {{ $t("место в очереди по категории") }} "{{ sideBarData.user.privilege.description }}"
                </template>
              </li>
            </ol>

            <h3 class="pb-4">{{ $t("Основная информация") }}</h3>

            <ol class="my_list my_list_dense mb-8">
              <li>
                <div>{{ $t("ИИН") }}</div>
                <div class="black--text">{{ sideBarData.user.iin }}</div>
              </li>
              <li>
                <div>{{ $t("ФИО") }}</div>
                <div class="black--text">{{ sideBarData.user.full_name }}</div>
              </li>
              <li>
                <div>{{ $t("Дата рождения") }}</div>
                <div class="black--text">{{ sideBarData.user.birthdate }}</div>
              </li>
              <li>
                <div>{{ $t("Адрес") }}</div>
                <div class="black--text">{{ sideBarData.user.address }}</div>
              </li>
              <li>
                <div>{{ $t("E-mail") }}</div>
                <div class="black--text">{{ sideBarData.user.email }}</div>
              </li>
              <li>
                <div>{{ $t("Телефон") }}</div>
                <div class="black--text">
                  {{ sideBarData.user.phone_number }}
                </div>
              </li>
              <li>
                <div>{{ $t("Статус") }}</div>
                <div class="black--text">
                  {{ sideBarData.user.status.name }}
                </div>
              </li>
              <li v-if="sideBarData.user.privilege">
                <div>{{ $t("Льгот") }}</div>
                <div class="black--text">
                  {{ sideBarData.user.privilege.description }}
                </div>
              </li>
            </ol>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
  
<script>
export default {
  mounted() {
      this.getData();
  },
  computed: {
    selectedLanguage() {
      return this.$store.getters.getLanguage;
    },
  },
  data() {
    return {
      languages: {
        kk: "Қазақша",
        ru: "Русский",
      },
      menuItems: {
        1: [
          {
            id: "main",
            url: "/main",
            name: this.$t("Главная"),
            icon: "mdi-account-multiple",
          },
          {
            id: "announce",
            url: "/announce/list",
            name: this.$t("Анонсы"),
            icon: "mdi-elevator-passenger",
          },
        ],
      },
      sideBarData: null,
      isLoading: false
    };
  },
  methods: {
    getData() {
      this.isLoading = true;
      this.$http.get("/main/user/status").then((response) => {
        this.sideBarData = response.data.data;
      });
      this.isLoading = false;
    },
    changeLanguage(lang) {
      this.$store.commit("setLanguage", lang);
      location.reload();
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>
  
<style lang="scss">
h2 {
  font-weight: 500;
}
.my_list {
  box-shadow: 0px 0px 4px 0px #00000040;
  border-radius: 10px;
  padding-left: 0 !important;
  list-style: none;
  background-color: #fff;
  li {
    padding: 12px 20px;
    color: #7a7a7a;
    + li {
      border-top: 1px solid #ccc;
    }
    &.active {
      color: #0075ff;
      font-size: 18px;
      padding: 15px 20px;
    }
    div:first-child {
      font-size: 12.5px;
    }
  }
  &.my_list_dense li {
    padding: 9px 20px;
  }
}
</style>